<template>
    <page-section class="page-section--xs pt-0" v-if="shows">
        <template slot="containerImmersive">
            <v-card color="grey lighten-5" rounded="xl" class="contract-card">
                <v-card-title>
                    <h4 class="txt txt--sm txt--dark font-weight-medium">리본바이옴 판매 계약서</h4>
                </v-card-title>
                <v-spacer />
                <v-card-text>
                    <v-row class="ma-n1 ma-md-n2">
                        <v-col cols="auto" class="pa-1 pa-md-2" v-if="createdAt">
                            <div class="txt txt--xs">
                                <span class="txt--dark mr-1">등록일</span>
                                <span class="grey--text text--lighten-1">{{ createdAt }}</span>
                            </div>
                        </v-col>
                        <v-col cols="auto" class="pa-1 pa-md-2" v-if="signedAt">
                            <div class="txt txt--xs">
                                <span class="txt--dark mr-1">서명일</span>
                                <span class="grey--text text--lighten-1">{{ signedAt }}</span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <contract-view v-if="isSigned">
                        <template #activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="primary" outlined class="rounded-sm v-size--xx-small px-3">계약서 보기</v-btn>
                        </template>
                    </contract-view>
                    <contract-sign v-else v-on="{ init }">
                        <template #activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="primary" class="rounded-sm v-size--xx-small px-3 ml-2">서명하기</v-btn>
                        </template>
                    </contract-sign>
                </v-card-actions>
            </v-card>
        </template>
    </page-section>
</template>

<script>
import api from "@/api";
import { initEmploymentContract } from "@/assets/variables";

import PageSection from "@/components/client/templates/page-section.vue";
import ContractSign from "./contract-sign.vue";
import ContractView from "./contract-view.vue";

function formatDate(date) {
    date = date?.toDateTime?.();
    date = date?.replaceAll?.("-", ". ");
    date = date?.slice?.(0, date?.lastIndexOf?.(":"));
    return date;
}

export default {
    components: {
        PageSection,
        ContractSign,
        ContractView,
    },
    data: () => ({
        contract: initEmploymentContract(),

        loading: false,
    }),
    computed: {
        shows() {
            return !!this.contract._id;
        },
        createdAt() {
            return formatDate(this.contract?.createdAt);
        },
        signedAt() {
            return formatDate(this.contract?.signedAt);
        },
        isSigned() {
            return this.contract?.isSigned;
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { contract } = await api.v1.me.employment.contract.get();
                this.contract = initEmploymentContract(contract);
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.contract-card {
    padding: 20px;
    .v-card {
        &__title,
        &__text,
        &__actions {
            padding: 0;
        }
        &__text {
            margin-top: 16px;
            width: auto;
        }
        &__actions {
            margin-top: 20px;
        }
    }
}
@media (min-width: 1024px) {
    .contract-card {
        padding: 24px;
        display: flex;
        align-items: center;
        .v-card {
            &__text {
                margin-top: 0;
            }
            &__actions {
                margin-top: 0;
                margin-left: 20px;
            }
        }
    }
}
@media (min-width: 1200px) {
    .contract-card {
        .v-card {
            &__actions {
                margin-left: 40px;
            }
        }
    }
}
</style>
